var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4396 1.5C26.1382 1.5 25.8319 1.58437 25.5549 1.76719L20.2222 4.97344V2.24063C20.2222 1.00313 19.0944 0 17.7042 0H2.51806C1.12778 0 0 1.00313 0 2.24063V15.7594C0 16.9969 1.12778 18 2.51806 18H17.7042C19.0944 18 20.2222 16.9969 20.2222 15.7594V13.0266L25.5549 16.2281C25.8319 16.4156 26.1431 16.4953 26.4396 16.4953C27.2465 16.4953 28 15.8859 28 15.0187V2.97656C28 2.10938 27.2465 1.5 26.4396 1.5ZM17.8889 6.375V15.6984C17.8597 15.7172 17.8014 15.75 17.7042 15.75H2.51806C2.42083 15.75 2.3625 15.7219 2.33333 15.6984V2.30156C2.3625 2.28281 2.42083 2.25 2.51806 2.25H17.7042C17.8014 2.25 17.8597 2.27812 17.8889 2.30156V6.375ZM25.6667 13.65L20.2222 10.3781V7.62656L25.6667 4.35469V13.65Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9ad3f026.svg";
export { ForwardRef as ReactComponent };